import { render, staticRenderFns } from "./BackPain.vue?vue&type=template&id=d94064d6&scoped=true"
import script from "./BackPain.vue?vue&type=script&lang=js"
export * from "./BackPain.vue?vue&type=script&lang=js"
import style0 from "./BackPain.vue?vue&type=style&index=0&id=d94064d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94064d6",
  null
  
)

export default component.exports